module.exports = __webpack_public_path__ + "img/accountDis.610932b8.svg";